import React from "react";
import styled from "styled-components";

const svgContainer = styled.div`
  path,
  polyline,
  line {
    fill: none;
  }

  path,
  line,
  circle {
    stroke-width: 2px;
    stroke-linecap: square;
    stroke-linejoin: square;
    stroke-miterlimit: 10;

    &.round {
      stroke-linecap: round;
      stroke-linejoin: round;
    }
  }

  .sw3 {
    stroke-width: 3px;
  }
`;

const svg = `<svg style="position: absolute; width: 0; height: 0; overflow: hidden;" version="1.1"
	xmlns="http://www.w3.org/2000/svg"
	xmlns:xlink="http://www.w3.org/1999/xlink">
	<defs>

	<symbol id="mtv" viewBox="0 0 48 48">
    <g clip-path="url(#clip0_1_187)">
    <path d="M23 0C10.3224 0 0 10.3224 0 23C0 35.6776 10.3224 46 23 46C35.6776 46 46 35.6776 46 23C46 10.3224 35.6776 0 23 0Z" fill="#FF3334"/>
    <path d="M37.7752 18.2712L35.1808 24.8768L33.12 18.5288H29.762L33.6444 28.2624H36.4964L39.3208 22.6136C39.9924 21.1232 39.2104 19.1084 37.7752 18.2712Z" fill="white"/>
    <path d="M28.0416 26.1832C27.1308 26.1832 26.864 25.3828 26.864 24.7112V20.8748H29.2008V18.5288H26.864V15.5848H26.6616C25.254 15.5848 23.8464 16.6796 23.8464 18.5288V24.5456C23.8412 25.1061 23.903 25.6651 24.0304 26.2108C24.4628 27.8852 26.0636 28.612 27.5816 28.612C28.5693 28.6098 29.5326 28.3047 30.3416 27.738L29.4584 25.668C29.2652 25.806 28.8236 26.1832 28.0416 26.1832Z" fill="white"/>
    <path d="M19.0532 18.2988C17.7192 18.2988 16.5508 18.7772 15.7596 19.6512C15.2352 18.9336 14.4164 18.2988 12.926 18.2988C11.8404 18.2988 10.488 19.0072 10.0096 19.8352L9.87158 18.308H9.67838C8.33518 18.3448 7.01038 19.3936 7.01038 20.8748V28.2624H10.028V23.0276C10.028 22.4112 10.212 21.896 10.5616 21.5004C10.7354 21.3022 10.9509 21.145 11.1927 21.04C11.4345 20.935 11.6965 20.8849 11.96 20.8932C12.4752 20.8932 12.8616 21.0588 13.1284 21.3716C13.3952 21.6844 13.5148 22.1444 13.5148 22.724V28.2624H16.4312V23.0276C16.4312 22.4112 16.606 21.896 16.9556 21.5004C17.3052 21.1048 17.7744 20.8932 18.3632 20.8932C18.952 20.8932 19.2648 21.0588 19.5224 21.3716C19.78 21.6844 19.9088 22.1444 19.9088 22.724V28.2624H22.9356V22.2456C22.9356 21.0312 22.6044 20.0652 21.9328 19.3568C21.2612 18.6484 20.3136 18.2988 19.0532 18.2988Z" fill="white"/>
    </g>
    <defs>
    <clipPath id="clip0_1_187">
    <rect width="46" height="46" fill="white"/>
    </clipPath>
    </defs>
	</symbol>

	<symbol id="mtv-dark" viewBox="29 29 141 141"">
		<style>.cls-1{fill:#ff3334;}.cls-2{fill:#fff;}</style>
		<g fill="#FFF"><circle fill="#FFF" r="69.7" cy="69.7" cx="69.7" transform="translate(30.314 30.314)"></circle><path fill="#1a2732" d="M114.43 55.33l-7.873 20.02-6.246-19.22h-10.17l11.78 29.46h8.642s8.246-16.48 8.528-17.107c2.04-4.51-.332-10.6-4.662-13.152zM84.938 79.319c-2.748 0-3.56-2.444-3.56-4.456V63.228h7.058V56.13h-7.058v-8.912h-.614c-4.275 0-8.54 3.328-8.54 8.912v18.233c-.02 1.692.172 3.38.572 5.025 1.287 5.092 6.154 7.29 10.741 7.29 2.994-.003 5.916-.925 8.37-2.64l-2.676-6.269c-.587.406-1.924 1.55-4.293 1.55zM57.707 55.437c-4.032 0-7.56 1.436-9.981 4.085-1.572-2.166-4.065-4.085-8.563-4.085-3.302 0-7.382 2.149-8.85 4.632l-.401-4.617h-.604c-4.062.107-8.083 3.288-8.083 7.763v22.38h9.16V69.75c0-1.883.54-3.433 1.619-4.65 1.08-1.216 2.489-1.824 4.228-1.824 1.565 0 2.74.495 3.525 1.446.785.95 1.176 2.327 1.176 4.087v16.774h8.825V69.741c0-1.883.53-3.433 1.587-4.65 1.058-1.216 2.477-1.824 4.258-1.824 1.565 0 2.743.495 3.525 1.446.783.95 1.179 2.327 1.179 4.087v16.774h9.16V67.377c0-3.684-1.008-6.595-3.021-8.734-2.014-2.139-4.926-3.207-8.739-3.206z" transform="translate(30.314 30.314)"></path></g>
	</symbol>

	<symbol id="mtv-pollo" viewBox="0 0 20 20"">
		<g clip-path="url(#clip0_1_462)">
		<path d="M10 0C4.47714 0 0 4.47714 0 10C0 15.5229 4.47714 20 10 20C15.5229 20 20 15.5229 20 10C20 4.47714 15.5229 0 10 0ZM10.0056 12.1826L9.17951 10.7519H10.8315L10.0055 12.1826H10.0056ZM14.2332 12.2408C12.3496 12.2408 10.7288 11.116 10.0056 9.5015C9.28233 11.116 7.66155 12.2408 5.77793 12.2408C3.2208 12.2408 1.14775 10.1678 1.14775 7.6106C1.14775 5.0534 3.2208 2.98043 5.778 2.98043C7.66162 2.98043 9.2824 4.10521 10.0056 5.71971C10.7289 4.10521 12.3497 2.98043 14.2333 2.98043C16.7904 2.98043 18.8634 5.0534 18.8634 7.6106C18.8634 10.1678 16.7905 12.2408 14.2333 12.2408H14.2332Z" fill="black"/>
		<path d="M14.2333 2.98047C12.3497 2.98047 10.7289 4.10525 10.0056 5.71975C9.2824 4.10525 7.66162 2.98047 5.778 2.98047C3.22087 2.98047 1.14783 5.05344 1.14783 7.61064C1.14783 10.1678 3.2208 12.2408 5.778 12.2408C7.66162 12.2408 9.2824 11.116 10.0056 9.50154C10.7289 11.116 12.3497 12.2408 14.2333 12.2408C16.7904 12.2408 18.8635 10.1678 18.8635 7.61064C18.8635 5.05344 16.7905 2.98047 14.2333 2.98047ZM6.46642 9.44625C5.54506 9.44625 4.79813 8.69932 4.79813 7.77795C4.79813 6.85658 5.54506 6.10966 6.46642 6.10966C7.38779 6.10966 8.13472 6.85658 8.13472 7.77795C8.13472 8.69932 7.38779 9.44625 6.46642 9.44625ZM13.5449 9.44625C12.6235 9.44625 11.8766 8.69932 11.8766 7.77795C11.8766 6.85658 12.6235 6.10966 13.5449 6.10966C14.4662 6.10966 15.2132 6.85658 15.2132 7.77795C15.2132 8.69932 14.4662 9.44625 13.5449 9.44625Z" fill="white"/>
		<path d="M10.0055 12.1827L10.8316 10.752H9.17957L10.0055 12.1827Z" fill="white"/>
		<path d="M6.46639 9.44621C7.38777 9.44621 8.13469 8.69929 8.13469 7.77792C8.13469 6.85654 7.38777 6.10962 6.46639 6.10962C5.54502 6.10962 4.7981 6.85654 4.7981 7.77792C4.7981 8.69929 5.54502 9.44621 6.46639 9.44621Z" fill="black"/>
		<path d="M14.7245 8.9575C15.376 8.30599 15.376 7.24968 14.7245 6.59817C14.073 5.94666 13.0167 5.94666 12.3652 6.59817C11.7137 7.24968 11.7137 8.30599 12.3652 8.9575C13.0167 9.60901 14.073 9.60901 14.7245 8.9575Z" fill="black"/>
		</g>
		<defs>
		<clipPath id="clip0_1_462">
		<rect width="20" height="20" fill="white"/>
		</clipPath>
		</defs>
	</symbol>
	<symbol id="checkmark" viewBox="1.5 20 23 23">
		<path d="M18.691,26.466c-0.024-0.1-0.087-0.184-0.176-0.237c-0.062-0.037-0.133-0.058-0.206-0.058
	c-0.138,0-0.263,0.068-0.334,0.183l-6.098,9.655l-3.872-5.069c-0.075-0.099-0.189-0.154-0.314-0.154
	c-0.086,0-0.167,0.026-0.235,0.076c-0.173,0.126-0.209,0.367-0.079,0.537l3.912,5.121c0.15,0.196,0.367,0.31,0.593,0.31h0.03
	c0.238-0.01,0.454-0.143,0.594-0.363l6.137-9.709C18.698,26.67,18.715,26.566,18.691,26.466"/>
	</symbol>

	<symbol id="refresh" viewBox="7 26.5 23 23">
		<path d="M27.715,38.492c0,5.082-4.135,9.216-9.215,9.216c-5.082,0-9.214-4.134-9.214-9.216
	c0-5.079,4.132-9.214,9.214-9.214c2.195,0,4.285,0.79,5.936,2.185h-2.93c-0.496,0-0.896,0.4-0.896,0.896s0.4,0.897,0.896,0.897
	h4.961c0.496,0,0.898-0.402,0.898-0.897v-4.961c0-0.497-0.402-0.897-0.898-0.897c-0.494,0-0.896,0.4-0.896,0.897v2.68
	c-1.969-1.655-4.457-2.592-7.07-2.592c-6.07,0-11.007,4.938-11.007,11.007c0,6.07,4.937,11.008,11.007,11.008
	s11.008-4.938,11.008-11.008c0-0.494-0.4-0.896-0.896-0.896S27.715,37.998,27.715,38.492z"/>
	</symbol>

	<symbol id="plus" viewBox="-8.5 10.5 23 23">
		<path d="M3,15.728v12.545 M-3.5,22h13"/>
	</symbol>

	<symbol id="minus" viewBox="0 0 23 23">
		<line x1="6.66" y1="11.5" x2="16.34" y2="11.5"/>
	</symbol>

	<symbol id="chevron-left" viewBox="0 0 23 23">
		<path class="round sw3" d="M14.471,17l-5.942-5.704L14.471,6"/>
	</symbol>

	<symbol id="chevron-right" viewBox="0 0 23 23">
		<path class="round sw3" d="M8.529,6l5.942,5.704L8.529,17"/>
	</symbol>

	<symbol id="chevron-up" viewBox="0 0 23 23">
		<path class="round sw3" d="M6,14.8l5.7-6.5l5.3,6.5"/>
	</symbol>

	<symbol id="chevron-down" viewBox="0 0 23 23">
		<path class="round sw3" d="M17,8.3l-5.7,6.5L6,8.3"/>
	</symbol>

	<symbol id="sort-up" viewBox="0 0 12 12">
		<polygon points="6,2 11,10 1,10">
	</symbol>

	<symbol id="sort-down" viewBox="0 0 12 12">
		<polygon points="6,10 1,2 11,2">
	</symbol>

	<symbol id="time" viewBox="0 0 23 23">
		<path d="M7.5,8.822c-0.486,0-0.882,0.278-0.882,0.62v4.935c0,0.342,0.396,0.62,0.882,0.62s0.883-0.278,0.883-0.62
	V9.442C8.383,9.1,7.986,8.822,7.5,8.822z M9.224,6.036c1.017-0.586,1.642-1.642,1.642-2.786C10.865,1.458,9.351,0,7.49,0
	C5.632,0,4.121,1.458,4.121,3.25c0,1.144,0.624,2.199,1.639,2.787C4.717,6.276,3.722,6.741,2.872,7.386l-0.945-0.91
	c-0.17-0.165-0.397-0.255-0.638-0.255S0.821,6.312,0.65,6.476C0.479,6.64,0.386,6.859,0.386,7.091S0.479,7.542,0.65,7.707
	l0.946,0.913C0.552,9.904,0,11.44,0,13.066c0,3.982,3.359,7.224,7.49,7.224c4.139,0,7.507-3.241,7.507-7.224
	C14.997,9.738,12.578,6.804,9.224,6.036z M7.49,19.094c-3.446,0-6.249-2.704-6.249-6.027c0-3.326,2.803-6.031,6.249-6.031
	c3.455,0,6.266,2.706,6.266,6.031C13.756,16.39,10.944,19.094,7.49,19.094z M7.49,1.196c1.176,0,2.133,0.921,2.133,2.054
	c0,0.8-0.48,1.521-1.23,1.859V3.678c0-0.479-0.405-0.87-0.903-0.87s-0.903,0.39-0.903,0.87v1.43C5.84,4.77,5.362,4.049,5.362,3.25
	C5.362,2.118,6.317,1.196,7.49,1.196z" />
	</symbol>

	<symbol id="cross" viewBox="0 0 23 23">
		<path d="M17.763,3 L5.707,15.056 M5.237,3l12.192,12.192"/>
	</symbol>

	<symbol id="arrow-down" viewBox="0 0 23 23">
		<polyline style="stroke-width:1.6" class="round" points="16.5,8.773 11.314,14.227 6.5,8.773 "/>
	</symbol>

	<symbol id="star" viewBox="0 0 23 23">
		<polygon points="11.5,7.65 12.7,10.35 15.4,11.55 12.7,12.65 11.5,15.35 10.3,12.65 7.6,11.45 10.3,10.25 "/>
	</symbol>

	<symbol id="stars" viewBox="0 0 23 23">
		<path d="M13.9,8l1.2,2.7l2.7,1.2L15.1,13l-1.2,2.7L12.7,13L10,11.8l2.7-1.2L13.9,8z M14.7,0.5l0.7,1.8 L17.1,3l-1.6,0.6l-0.7,1.6L14,3.6L12.3,3L14,2.3L14.7,0.5z M6.9,5.9l0.7,1.8l1.6,0.6L7.7,9l-0.7,1.6L6.2,9L4.6,8.4l1.6-0.6L6.9,5.9z M16.1,17.7l0.7,1.8l1.6,0.6l-1.6,0.6l-0.7,1.6l-0.7-1.6l-1.6-0.6l1.6-0.6L16.1,17.7z"/>
	</symbol>

	<symbol id="facebook" viewBox="-8 11 23 23">
		<path d="M9.286,14.5H-2.286c-1.221,0-2.214,0.993-2.214,2.214v11.572c0,1.221,0.993,2.214,2.214,2.214
	H9.286c1.221,0,2.214-0.993,2.214-2.214V16.714C11.5,15.493,10.507,14.5,9.286,14.5z M10.262,28.286
	c0,0.538-0.438,0.976-0.976,0.976H5.675v-4.615h1.663c0.147,0,0.287-0.124,0.305-0.271l0.186-1.582
	c0.008-0.064-0.01-0.125-0.049-0.169c-0.04-0.045-0.098-0.069-0.164-0.069H5.669c0-0.523,0.001-1.16,0.001-1.401
	c0-0.714,0.467-1.19,1.189-1.217c0.187-0.007,0.406-0.011,0.672-0.011c0.098,0,0.138,0.002,0.232,0.002
	c0.113,0,0.185-0.053,0.185-0.191c0-0.418-0.001-1.469-0.001-1.469c0-0.17-0.083-0.235-0.271-0.25
	c-0.235-0.02-0.472-0.034-0.722-0.043c-0.169-0.006-0.351-0.011-0.541-0.011c-0.438,0-0.773,0.029-1.024,0.091
	c-0.702,0.169-1.207,0.528-1.543,1.098c-0.253,0.43-0.38,0.91-0.388,1.467c-0.006,0.407-0.006,1.41-0.006,1.936H1.776
	c-0.069,0-0.133,0.027-0.182,0.076s-0.076,0.113-0.076,0.182l0,1.576c0,0.068,0.026,0.133,0.076,0.182
	c0.049,0.049,0.113,0.076,0.182,0.076h1.677l0,4.615h-5.739c-0.538,0-0.976-0.438-0.976-0.976V16.714
	c0-0.538,0.438-0.976,0.976-0.976H9.286c0.538,0,0.976,0.438,0.976,0.976V28.286L10.262,28.286z"/>
	</symbol>

	<symbol id="twitter" viewBox="-6.5 11 23 23">
		<path d="M1.647,30.5c-1.025,0-1.954-0.118-2.84-0.361c-0.939-0.258-1.866-0.652-2.833-1.206
	c-0.065-0.038-0.119-0.076-0.162-0.106c-0.012-0.01-0.024-0.018-0.036-0.026c-0.192-0.133-0.297-0.36-0.273-0.593l0.006-0.059
	c0.036-0.345,0.339-0.599,0.684-0.572c0.22,0.018,0.439,0.025,0.652,0.025c1.087,0,2.082-0.219,3.012-0.664
	c-0.319-0.137-0.609-0.307-0.879-0.514c-0.739-0.565-1.249-1.283-1.515-2.133c-0.062-0.197-0.025-0.413,0.1-0.578
	c0.015-0.02,0.031-0.039,0.048-0.057c-0.207-0.178-0.393-0.373-0.557-0.584c-0.557-0.716-0.868-1.62-0.923-2.688
	c-0.011-0.223,0.095-0.438,0.281-0.562c0.075-0.051,0.159-0.084,0.246-0.1c-0.658-1.217-0.659-2.606,0.003-4.149
	c0.083-0.194,0.256-0.334,0.462-0.374c0.206-0.041,0.419,0.022,0.569,0.17l0.31,0.304c0.204,0.2,0.398,0.39,0.591,0.581
	c1.569,1.546,3.418,2.445,5.639,2.737c0-0.092,0-0.184-0.001-0.275c-0.007-0.927,0.338-1.858,0.97-2.626
	c0.653-0.791,1.557-1.327,2.548-1.509c0.294-0.054,0.587-0.081,0.87-0.081c1.071,0,2.025,0.377,2.837,1.12
	c0.066,0.062,0.144,0.126,0.212,0.183c0.625-0.008,1.77-0.043,2.137-0.076c0.189-0.018,0.375,0.051,0.509,0.185
	s0.201,0.321,0.184,0.511c-0.011,0.119-0.146,1.203-1.528,2.664c-0.01,0.01-0.02,0.02-0.029,0.028
	c-0.014,0.698-0.058,1.596-0.264,2.494c-0.697,3.04-2.294,5.427-4.744,7.093c-1.389,0.945-2.924,1.516-4.562,1.697
	C2.755,30.467,2.192,30.5,1.647,30.5z M-1.471,28.715c0.205,0.071,0.41,0.135,0.615,0.191c0.775,0.213,1.594,0.316,2.503,0.316
	c0.497,0,1.015-0.031,1.582-0.094c1.43-0.158,2.771-0.658,3.985-1.484c1.105-0.752,2.021-1.672,2.724-2.736
	c0.684-1.037,1.187-2.243,1.495-3.586c0.186-0.811,0.222-1.65,0.232-2.291c0.006-0.35,0.139-0.629,0.404-0.854
	c0.41-0.438,0.678-0.822,0.85-1.128c-0.564,0.02-1.184,0.032-1.473,0.032c-0.14,0-0.275-0.046-0.387-0.131
	c-0.01-0.008-0.258-0.197-0.465-0.388c-0.568-0.521-1.234-0.786-1.977-0.786c-0.207,0-0.422,0.021-0.641,0.061
	c-1.559,0.285-2.481,1.684-2.473,2.869c0.001,0.22,0,0.439,0,0.663c0,0.106,0,0.214,0,0.321c0,0.35-0.279,0.633-0.626,0.64
	c-0.017,0.001-0.037,0.001-0.06,0.001c-0.032,0-0.062-0.001-0.092-0.004c-2.762-0.224-5.127-1.288-7.03-3.164
	c-0.056-0.056-0.113-0.111-0.169-0.166c-0.281,1.283,0.125,2.345,1.245,3.291c0.212,0.18,0.284,0.475,0.178,0.732
	c-0.105,0.256-0.364,0.416-0.641,0.393c-0.256-0.02-0.505-0.059-0.75-0.114c0.304,1.038,1.032,1.723,2.237,2.123
	c0.27,0.09,0.448,0.347,0.437,0.632s-0.209,0.527-0.484,0.596c-0.205,0.05-0.415,0.081-0.655,0.096
	c0.176,0.243,0.394,0.463,0.655,0.662c0.463,0.355,1.036,0.56,1.803,0.645c0.26,0.028,0.476,0.213,0.545,0.467
	c0.069,0.252-0.023,0.521-0.233,0.68C0.846,27.965-0.271,28.473-1.471,28.715z"/>
	</symbol>

	<symbol id="instagram" viewBox="-8 11 23 23">
		<path d="M7,17.5c0.275,0,0.5-0.225,0.5-0.5S7.275,16.5,7,16.5S6.5,16.725,6.5,17S6.725,17.5,7,17.5z M8.223,14.5
	h-9.446c-1.807,0-3.277,1.471-3.277,3.277v2.303v7.143c0,1.807,1.47,3.277,3.277,3.277h9.446c1.807,0,3.277-1.471,3.277-3.277V20.08
	v-2.303C11.5,15.971,10.029,14.5,8.223,14.5z M-3.262,17.777c0-1.125,0.915-2.039,2.039-2.039h9.446
	c1.125,0,2.039,0.914,2.039,2.039v1.684H5.934c-0.055-0.043-0.11-0.086-0.166-0.126c-0.665-0.478-1.449-0.729-2.268-0.729
	s-1.603,0.252-2.267,0.729c-0.056,0.04-0.112,0.083-0.166,0.126h-4.329V17.777z M1.712,20.537c0.077-0.07,0.158-0.137,0.243-0.196
	c0.453-0.325,0.987-0.497,1.545-0.497c0.559,0,1.093,0.172,1.546,0.496c0.084,0.061,0.165,0.127,0.243,0.197l0,0
	C5.84,21.04,6.156,21.756,6.156,22.5c0,1.465-1.191,2.656-2.656,2.656S0.844,23.965,0.844,22.5
	C0.844,21.756,1.16,21.04,1.712,20.537z M10.262,27.223c0,1.125-0.914,2.039-2.039,2.039h-9.446c-1.125,0-2.039-0.914-2.039-2.039
	v-6.523h3.312c-0.288,0.551-0.443,1.168-0.443,1.801c0,2.146,1.747,3.895,3.894,3.895c2.147,0,3.895-1.748,3.895-3.895
	c0-0.633-0.156-1.25-0.443-1.801h3.311V27.223L10.262,27.223z"/>
	</symbol>

	<symbol id="filter-add" viewBox="0 0 30 30">
		<g>
			<circle cx="14" cy="14" r="13"></circle>
			<g transform="translate(8, 8)">
				<path d="M6,0 L6,11.5500002"></path>
				<path d="M0,6 L11.6800003,6"></path>
			</g>
		</g>
	</symbol>

	<symbol id="filter-del" viewBox="0 0 30 30">
		<g>
			<circle cx="14" cy="14" r="13"></circle>
			<g transform="translate(9, 13)">
				<path d="M0,1 L9.68000031,1"></path>
			</g>
		</g>
	</symbol>

	<symbol id="search" viewBox="0 0 40 40">
		<path id="_x36_F" class="st0" d="M23.5,28.1c-3.3,0-6.2-1.3-8.4-3.4c0,0,0,0,0,0c0,0,0,0,0,0c-2.2-2.2-3.6-5.2-3.6-8.5
			c0-6.6,5.4-12,12-12s12,5.4,12,12C35.5,22.7,30.1,28.1,23.5,28.1z M8.5,16.3c0,3.7,1.3,7.1,3.5,9.7L1.6,36.3c-0.6,0.6-0.6,1.5,0,2.1
			c0.3,0.3,0.7,0.4,1.1,0.4s0.8-0.1,1.1-0.4l10.4-10.4c2.6,2.1,5.9,3.4,9.5,3.4c8.4,0,15.2-6.8,15.2-15.2c0-8.4-6.8-15.2-15.2-15.2
			C15.3,1.1,8.5,7.9,8.5,16.3z"/>
	</symbol>

	<symbol id="date" viewBox="0 0 24 26">
		<path d="M22.8,1.3h-4.5V0.9c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9v0.4H7.7V0.9C7.7,0.4,7.4,0,6.8,0
			C6.4,0,6,0.4,6,0.9v0.4H1.3C0.5,1.3,0,1.8,0,2.6v5v17.2C0,25.5,0.5,26,1.3,26h21.4c0.7,0,1.3-0.5,1.3-1.2V7.6v-5
			C24.1,1.9,23.5,1.3,22.8,1.3z M1.8,3.1H6v0.4C6,4,6.4,4.4,6.9,4.4c0.5,0,0.9-0.4,0.9-0.9V3.1h8.8v0.4c0,0.5,0.4,0.9,0.9,0.9
			c0.5,0,0.9-0.4,0.9-0.9V3.1h4v3.6H1.9L1.8,3.1L1.8,3.1z M22.3,24.2H1.8V8.4h20.5V24.2z M5.3,12.5H8v2.6H5.3V12.5z M10.8,12.5h2.6
			v2.6h-2.6V12.5z M16.2,12.5h2.6v2.6h-2.6V12.5z M5.3,17.6H8v2.6H5.3V17.6z M10.8,17.6h2.6v2.6h-2.6V17.6z M16.2,17.6h2.6v2.6h-2.6
			V17.6z"/>
	</symbol>

	</defs>
</svg>`;

const SVGDefs = () => <svgContainer dangerouslySetInnerHTML={{ __html: svg }} />;

export default SVGDefs;



// WEBPACK FOOTER //
// ./src/icons/svgdefs.js